//= Functions & Modules
// Others
import React from 'react';

//= React components
// Own
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBolt } from '@fortawesome/free-solid-svg-icons';
import { ConnectionStatus } from '../modules/server';

type Props = {
    className?: string;
};

export default class Top extends React.PureComponent<Props> {
    static defaultProps = {
        className: '',
    };

    render() {
        return (
            <div
                className={`flex justify-between items-center h-14 px-4 bg-[#13161a] flex-shrink-0 ${this.props.className}`}
                style={{ borderBottom: '1px solid rgba(255,255,255,0.07)' }}
            >
                <div className="flex items-center gap-2.5">
                    <FontAwesomeIcon icon={faBolt} className="text-accent text-base" />
                    <span className="font-semibold text-title tracking-wide text-sm">Trading Bot</span>
                </div>
                <ConnectionStatus />
            </div>
        );
    }
}
